import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      // Background colors used in whole website will be grouped under this
      backgroundColor: '#FAF9FA',
      backgroundColor2: '#FFFFFF',
      backgroundColor3: '#EDEBEE',
      backgroundColor4: '#F5EBDA',
      backgroundColor5: '#B6AEBA',
      backgroundColor6: '#E8F4FE',
      // Text Colors used in whole website will be grouped under this
      textColor: '#FFFFFF',
      textColor2: '#F5EBDA',
      textColor3: '#493553',
      textColor4: '#323435',
      textColor5: '#6D5D75',
      light: '#676F7B',
      toggleHover: '#FBECFB',
      main: '#424B5A',
      dark: '#2E343E',
      contrast: '#323435',
      contrastText: '#FFF',
      offerTag: '#FFC800',
      offerMain: '#892BA0',
      OfferSelected: '#470A68',
      infoBannerButtonText: '#480B69',
      offerPromo: 'rgba(50, 52, 53, 0.54)',
      disableCTA: 'rgba(50, 52, 53, 0.38)',
      arrows: 'rgba(0,0,0,0.12)',
      inactive: '#B1B2B2',
      hoverCTA: '#B10071',
      background: 'rgba(208, 208, 208, 1)',
      primaryBackground: '#FAF5ED',
      offerBackground: '#F1A5C9',
      modalText: 'rgba(50, 52, 53, 0.87)',
      disabled: '#959596',
      simoSelected: '#35074E',
      header: '#ECECEC',
      headerText: '#000000',
      eirButton: '#d011c9',
      orange: '#ED8B00',
      lightGrey: '#F7F7F7',
      moreInfo: '#460A67',
      nullColor: '#2c292973',
      infoBannerBackround: '#493553',
      disabledCTABackground: '#949595',
      SkeletonBackground: '#E6E6E6',
      boxShadow: '#D0D0D0',
      boxShadow1Lite: 'rgba(209, 17, 201, 0.12)',
      boxShadow1Medium: 'rgba(209, 17, 201, 0.14)',
      boxShadow1Dark: 'rgba(209, 17, 201, 0.2)',
      boxShadow1Darkest: 'rgba(209, 17, 201, 0.4)',
      boxShadow2Lite: 'rgba(136, 139, 141, 0.12)',
      boxShadow2Medium: 'rgba(136, 139, 141, 0.14)',
      boxShadow2Dark: 'rgba(136, 139, 141, 0.2)',
      boxShadow3: 'rgba(255, 255, 255, 0)',
      boxShadow3Lite: 'rgba(255, 255, 255, 0.62)',
      boxShadow3Medium: 'rgba(255, 255, 255, 0.8)',
      boxShadow3Dark: 'rgba(255, 255, 255, 0.9)',
      boxShadow4: 'rgba(0,0,0,0.0)',
      boxShadow4Lite: 'rgba(0,0,0,0.2)',
      boxShadow4Medium: 'rgba(0,0,0,0.3)',
      boxShadow4Dark: 'rgba(0,0,0,0.7)',
      boxShadow5Medium: 'rgba(208, 208, 208, 0.5)',
      buttonColor: '#DD1D78',
      buttonPrimaryHoverColor: '#9B1454',
      buttonInactiveColor: '#888B8D',
      boxShadowScrollbar: 'rgba(0,0,0,0.00)',
    },
    secondary: {
      light: '#F3F5F9',
      main: '#C2D1D9',
      dark: '#879297',
      offerMain: '#009DD1',
      OfferSelected: '#003380',
      contrastText: '#FFFFFF',
      greyBackground: '#CDCDCD',
      greenBackground: '#43B02A',
      greenCta: 'rgba(67, 176, 42, 0.15)',
      errorCTA: '#D111C9',
      errorMsg: '#f44336',
      radioText: '#888B8D',
      activeSlide: '#C495CF',
      asterisk: '#E40046',
      backgroundGrey: '#A7A7A7',
      borderGrey87: '#DEDEDE',
      borderGrey92: '#EBEBEB',
      calendarGray40: '#666666',
      validateBoxShadow: '#E0E0E0',
      boxShadow: 'rgba(51, 51, 51, 0.5)',
      boxShadow1: 'rgba(170, 170, 170, 0.03)',
      boxShadow2: 'rgb(33, 150, 243)',
      footerBackground: '#F5F5F5',
      handsetColorBackground: '#f3f3f3',
      mobileActiveToggleBackground: '#493552',
      mobileActiveToggleBackgroundLight: '#493553',
      bundleCardBodyBackground: '#F5EBDA',
      bundleCardFooterBackground: '#6C5B71',
      bundleCardFooterBackground2: '#332539',
      mobileToggleColor: '#EDEBEE',
      mobileInActiveToggleFontColor: '#6A5971',
      breadcrumbBackground: '#6D5D75',
    },
    error: {
      main: red.A400,
    },
  },

  typography: {
    h1Large: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '3.375rem',
      lineHeight: '3.875rem',
      mobileView: {
        fontSize: '2.331rem',
        lineHeight: '2.831rem',
      },
    },
    h1: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '2.5rem',
      lineHeight: '3rem',
      mobileView: {
        fontSize: '1.538rem',
        lineHeight: '2.225rem',
      },
    },
    h2Large: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '3.375rem',
      lineHeight: '3.875rem',
      mobileView: {
        fontSize: '2.331rem',
        lineHeight: '2.831rem',
      },
    },
    h2: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '2rem',
      lineHeight: '2.5rem',
      mobileView: {
        fontSize: '1.35rem',
        lineHeight: '2.038rem',
      },
    },
    h3: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1.5rem',
      lineHeight: '2.25',
      mobileView: {
        fontSize: '1.25rem',
        lineHeight: '1.938rem',
      },
    },
    h4: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      mobileView: {
        fontSize: '1.163rem',
        lineHeight: '1.844rem',
      },
    },
    h5: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1.125rem',
      lineHeight: '1.75rem',
      mobileView: {
        fontSize: '1.069rem',
        lineHeight: '1.75rem',
      },
    },
    h6: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      mobileView: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },

    subtitle1: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      mobileView: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },
    subtitle2: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
      mobileView: {
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
      },
    },
    subtitle3: {
      fontFamily: 'eirsans-bold',
      fontWeight: '400',
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
      mobileView: {
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
      },
    },

    body1: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',

      mobileView: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },
    body2: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
      mobileView: {
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
      },
    },
    body3: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
      mobileView: {
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
      },
    },
    body3Medium: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
      mobileView: {
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
      },
    },

    caption: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '0.813rem',
      lineHeight: '1.25rem',
      mobileView: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },
    overline: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '0.75rem',
      lineHeight: '1.375rem',
      mobileView: {
        fontSize: '0.75rem',
        lineHeight: '1.375rem',
      },
    },

    avatarLetter: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
      mobileView: {
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
      },
    },
    inputLabel: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '0.75rem',
      lineHeight: '0.75rem',
      mobileView: {
        fontSize: '0.75rem',
        lineHeight: '0.75rem',
      },
    },
    helperText: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '0.875rem',
      lineHeight: '1.375rem',
      mobileView: {
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
      },
    },
    inputText: {
      fontFamily: 'eirsans-light',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      mobileView: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
      },
    },

    textFeildMessage: {
      fontFamily: 'Roboto',
      fontWeight: 'inherit',
      fontSize: '0.75rem',
      lineHeight: '1.245rem',
    },

    tooltip: {
      fontFamily: 'eirsans-regular',
      fontWeight: '400',
      fontSize: '0.625rem',
      lineHeight: '1.125rem',
      mobileView: {
        fontSize: '0.625rem',
        lineHeight: '1.125rem',
      },
    },

    a: {
      fontFamily: 'gt-walsheim-regular',
      textDecoration: 'underline',
      // color: 'black',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'buttonLarge' },
          style: {
            borderRadius: '0.375rem',
            fontFamily: 'eirsans-bold',
            fontWeight: '400',
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
            textTransform: 'none',
            cursor: 'pointer',
          },
        },
        {
          props: { variant: 'buttonMedium' },
          style: {
            borderRadius: '0.375rem',
            fontFamily: 'eirsans-bold',
            fontWeight: '400',
            fontSize: '1rem',
            lineHeight: '1.5rem',
            textTransform: 'none',
            cursor: 'pointer',
          },
        },
        {
          props: { variant: 'buttonSmall' },
          style: {
            borderRadius: '0.375rem',
            fontFamily: 'eirsans-bold',
            fontWeight: '400',
            fontSize: '0.875rem',
            lineHeight: '1.375rem',
            textTransform: 'none',
            cursor: 'pointer',
          },
        },
        {
          props: { variant: 'altCta' },
          style: {
            border: `none`,
            fontFamily: 'eirsans-regular',
            fontStyle: 'normal',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            textTransform: 'none',
            cursor: 'pointer',
          },
        },
      ],
    },
  },
});

theme.typography.h1 = {
  fontSize: theme?.typography?.h1?.fontSize,
  fontFamily: theme?.typography?.h1?.fontFamily,
  fontWeight: theme?.typography?.h1?.fontWeight,
  lineHeight: theme?.typography?.h1?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h1?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h1?.mobileView?.lineHeight,
  },
};

theme.typography.h2 = {
  fontSize: theme?.typography?.h2?.fontSize,
  fontFamily: theme?.typography?.h2?.fontFamily,
  fontWeight: theme?.typography?.h2?.fontWeight,
  lineHeight: theme?.typography?.h2?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h2?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h2?.mobileView?.lineHeight,
  },
};
theme.typography.h3 = {
  fontSize: theme?.typography?.h3?.fontSize,
  fontFamily: theme?.typography?.h3?.fontFamily,
  fontWeight: theme?.typography?.h3?.fontWeight,
  lineHeight: theme?.typography?.h3?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h3?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h3?.mobileView?.lineHeight,
  },
};

theme.typography.h4 = {
  fontSize: theme?.typography?.h4?.fontSize,
  fontFamily: theme?.typography?.h4?.fontFamily,
  fontWeight: theme?.typography?.h4?.fontWeight,
  lineHeight: theme?.typography?.h4?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h4?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h4?.mobileView?.lineHeight,
  },
};

theme.typography.h5 = {
  fontSize: theme?.typography?.h5?.fontSize,
  fontFamily: theme?.typography?.h5?.fontFamily,
  fontWeight: theme?.typography?.h5?.fontWeight,
  lineHeight: theme?.typography?.h5?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h5?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h5?.mobileView?.lineHeight,
  },
};

theme.typography.h6 = {
  fontSize: theme?.typography?.h6?.fontSize,
  fontFamily: theme?.typography?.h6?.fontFamily,
  fontWeight: theme?.typography?.h6?.fontWeight,
  lineHeight: theme?.typography?.h6?.lineHeight,
  color: theme?.palette?.primary?.offerMain,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.h6?.mobileView?.fontSize,
    lineHeight: theme?.typography?.h6?.mobileView?.lineHeight,
  },
};

theme.typography.body1 = {
  fontSize: theme?.typography?.body1?.fontSize,
  fontFamily: theme?.typography?.body1?.fontFamily,
  fontWeight: theme?.typography?.body1?.fontWeight,
  lineHeight: theme?.typography?.body1?.lineHeight,
  color: theme?.palette?.primary?.contrast,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.body1?.mobileView?.fontSize,
    lineHeight: theme?.typography?.body1?.mobileView?.lineHeight,
  },
};

theme.typography.body2 = {
  fontSize: theme?.typography?.body2?.fontSize,
  fontFamily: theme?.typography?.body2?.fontFamily,
  fontWeight: theme?.typography?.body2?.fontWeight,
  lineHeight: theme?.typography?.body2?.lineHeight,
  color: theme?.palette?.primary?.contrast,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme?.typography?.body2?.mobileView?.fontSize,
    lineHeight: theme?.typography?.body2?.mobileView?.lineHeight,
  },
};

export default theme;
